
import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { UserService } from '../../../services';
@Component({
  selector: 'sandbox-graph',
  templateUrl: './sandbox-graph.component.html',
  styleUrls: ['./sandbox-graph.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SandboxGraphComponent implements OnInit {
  @Input('graphId') graphId: number;
  @Input('wigetData') wigetData: any;
  @Input('groupId') groupId: any;
  @Input('groupData') groupDataActual: any;
  @Input('isEditable') isEditable: any;
  userOffSet: string;

  groupData: any = {};
  graphData: any = { timeFrame: "", kpiType: "", fetchDataFor: "", dataFilter: "", events: "", binFilter: "" };
  componentData: any = { timeFrame: "", kpiType: "", fetchDataFor: "", dataFilter: "", events: "", binFilter: "" };

  constructor(private userService: UserService,) { }

  ngOnInit() {
    this.groupData = Object.assign({}, this.groupDataActual);
    if (this.wigetData.kpiType == "siteMap") {
      this.graphData.kpiType = this.wigetData.kpiType;
      this.graphData.fetchDataFor = this.wigetData.fetchDataFor;
      this.graphData.dataFilter = this.wigetData.dataFilter;
      this.graphData.udf = { widgetId: this.wigetData._id };
      return;
    }
    if (this.wigetData.response.fetchDataFor === 'column')
      this.wigetData.response.fetchDataFor = 'bar';
    this.graphData = this.wigetData.response;
    this.componentData = this.wigetData.response;
    let userOff = this.userService.getLoggedInUser();
    this.userOffSet = userOff.settings.localOffSet;
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/sandbox-graph/sandbox-graph.component.ts